import React from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector } from "react-redux";
import styles from './MyPropertyPromoMobile.less';
import tracking from '../../tracking/tracking.js';
import { TAB, navigateTo } from '../Navigation/Menu/menuConfig';
import { FUTURE_PRICE_TREND_LINK_MY_PROPERTY } from '../../tracking/trackingNaming.js';
import { getHierarchyLevel } from "../../selectors/selectors";

export const MyPropertyPromoMobile = ({ history, trackingAction }) => {
  const hierarchyLevel = useSelector(getHierarchyLevel);
  const handleButtonClick = (event, hierarchyLevel) => {
    tracking.report(FUTURE_PRICE_TREND_LINK_MY_PROPERTY, trackingAction);
    event.preventDefault();
    if (hierarchyLevel === 'country') {
      window.location.pathname = '/eigentuemerbereich';
    } else {
      const destinationTAB = TAB.myProperty;
      navigateTo(history, destinationTAB);
    }
  };

  return (
    <div data-identifier="my-property-promo" className={`grid padding-horizontal-m ${styles.myPropertyPromoContainer}`}>
      <div className="grid-item one-whole">
        <p className={styles.headline}>
          <span className={`is24-icon-lock-unlock margin-right-s font-confirm ${styles.lockIcon}`} />
          Preisprognose freischalten
        </p>
      </div>
      <div className="grid-item one-whole margin-top-s">
        <p className={styles.text}>Jetzt Preisprognose für ein Jahr der eigenen Immobilie anzeigen lassen.</p>
      </div>
      <div className="grid-item one-whole">
        <button
          id="my-property-promo-button"
          type="button"
          className={`link-text margin-top-s padding-none ${styles.button}`}
          onClick={(event) => handleButtonClick(event, hierarchyLevel)}
        >
          Zum Eigentümerbereich
        </button>
      </div>
    </div>
  );
};

export default withRouter(MyPropertyPromoMobile);
